// removed by extract-text-webpack-plugin
module.exports = {"header":"FDSbt _2oaig _28zmO","picker":"_1ce3s","heading":"_14CMD _1v96X _2Eplg _1YmAR","footer":"_27Myx _1v96X _2Eplg hhMuP","options":"_2W_n3 wDJGN _3BXGR _13ixQ","option":"pBb4u _1wqBz _1Q5o6","optionContent":"dyy4K _1jweU _3BXGR _1-OXK _3Xg8b _1v96X","optionBackground":"RhYv_ _3N3R0","selected":"_2NDg1","name":"_1w9LI","mainIcon":"_2yZ33 _2gWZX b24O2","removeIcon":"_2NBQo _2irZW b24O2"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/LabelPicker.css
// module id = 2016
// module chunks = 3